import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	searchIconLabel: {
		id: 'dropdown_search_icon_label',
		defaultMessage: 'Search',
		description: 'Label text for search icon',
	},
});
